/**
 * The origins the Sounds and Labs plugins' host page can have, one per webview
 * engine. macOS (WKWebView) serves the host page from a custom scheme; Windows
 * (WebView2) cannot, so it serves it over https on the same host name. The
 * handshake must be accepted from either, or the port and auth token never
 * arrive on Windows. Source of truth: `core/libs/plugin-core/cpp/WebView.cpp`
 * in the platform repo.
 *
 * A port-suffixed origin (the local dev server on :9040) or an http origin is
 * deliberately not accepted, so a page that merely shares the host name cannot
 * pose as the plugin.
 */
export const kPluginParentOrigins: readonly string[] = [
    "splice-plugin://local.splice.com", // macOS, WKWebView custom scheme
    "https://local.splice.com", // Windows, WebView2
];

export const isPluginParentOrigin = (origin: string): boolean =>
    kPluginParentOrigins.includes(origin);
